import Modal from "react-bootstrap/Modal";
import { ButtonView } from "../../controls";
//
import "./ModalStyles.scss";
function ModalView({
  modalStyles,
  show,
  handleClose,
  size,
  center,
  showCloseIcon,
  title,
  modalHeaderStyles,
  modalBodyStyles,
  children,
  showCloseButton = false,
  showSubmitButton = false,
  submitTitle,
  cancelTitle,
  onClickConfirm,
  footer,
  showCancelBtn,
  modalFooterStyles,
  isImageModal = false,
}) {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size={size}
      centered={center}
      className={modalStyles}
    >
      <Modal.Header
        className={`${isImageModal && "d-none"} ${modalHeaderStyles}`}
        closeButton={showCloseIcon}
      >
        <Modal.Title>{title}</Modal.Title>
        <div className={`close-btn ${!showCancelBtn && "d-none"}`}>
          <ButtonView
            title={cancelTitle ? cancelTitle : "Cancel"}
            styles={"light cancel-btn"}
            onClick={handleClose}
            extraStyles={"btn-control"}
          />
        </div>
      </Modal.Header>
      <Modal.Body className={`${isImageModal && "p-0"} ${modalBodyStyles}`}>
        {children}
      </Modal.Body>
      <Modal.Footer
        className={`${isImageModal && "d-none"} ${modalFooterStyles}`}
      >
        {footer ? footer : null}
        {showSubmitButton && (
          <ButtonView
            title={submitTitle ? submitTitle : "submit"}
            styles={"primal"}
            onClick={onClickConfirm}
            extraStyles={"btn-control"}
          />
        )}
        {showCloseButton && (
          <ButtonView
            title={"Close"}
            styles={"primal"}
            onClick={handleClose}
            extraStyles={"btn-control"}
          />
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default ModalView;
